'use client';

import { useAppStore } from '@/lib/stores/app-store';
import { WelcomeScreen, SelectScreen, LearnScreen } from '@/components';

export default function Home() {
  const { screen } = useAppStore();

  switch (screen) {
    case 'welcome':
      return <WelcomeScreen />;
    case 'select':
      return <SelectScreen />;
    case 'learn':
      return <LearnScreen />;
    default:
      return <WelcomeScreen />;
  }
}
